import { useStoreOnboardingClinicPractitionerQuery } from "@practitioner/data/queries/StoreOnboardingQuery/StoreOnboarding.query.generated";
import { useFlippers } from "@shared/context/FlippersContext";
import { useCertifications } from "@shared/hooks/useCertifications/useCertifications";
import { useSharedGlobalConfig } from "@shared/hooks/useSharedGlobalConfig/useSharedGlobalConfig";
import { useIsFsEmbedVar } from "@shared/reactiveVar/useIsFsEmbedVar/useIsFsEmbedVar.store";

const ACCOUNT_SETUP_RELEASE_DATE = new Date("2025-05-26T13:00:00Z");

const useSonicAccountSetupExperiment = () => {
  const [isSonicAccountSetupFlipper] = useFlippers("sonic_account_setup_improvements");
  const { isUnauthenticated } = useSharedGlobalConfig();
  const { data: storeOnboardingData, loading } = useStoreOnboardingClinicPractitionerQuery();
  const isFsEmbed = useIsFsEmbedVar();
  const { isCertified, loading: certificationLoading } = useCertifications(isUnauthenticated);

  if (
    loading ||
    certificationLoading ||
    !storeOnboardingData?.currentStore ||
    !storeOnboardingData?.currentPractitioner?.properties
  ) {
    return false;
  }

  const { createdAt } = storeOnboardingData.currentStore;
  const { isStoreOwner = false } = storeOnboardingData.currentPractitioner.properties;
  const isCreatedAfterReleaseDate = new Date(createdAt) > ACCOUNT_SETUP_RELEASE_DATE;

  return (
    isSonicAccountSetupFlipper &&
    !loading &&
    isStoreOwner &&
    (isCreatedAfterReleaseDate || !isCertified) &&
    !isFsEmbed
  );
};

export { useSonicAccountSetupExperiment };
